import { config } from '@vue/test-utils'

import { createI18n } from 'vue-i18n'
import ar from '@/i18n/ar/ar.js'
import en from '@/i18n/en/en.js'

const i18n = createI18n({
  locale: 'en',
  legacy: false,
  fallbackLocale: 'en',
  missingWarn: false,
  fallbackWarn: false,
  messages: {
    en,
    ar
  }
})

config.global.plugins = [i18n]
config.global.mocks.$t = (key) => key

export default i18n
